import React, { ReactElement } from 'react';
import { LoaderWrapper, LoaderWrapperProps } from '../LoaderWrapper';

type LoaderSpinnerSizes = 'small' | 'default' | 'large';

export interface LoaderSpinnerProps
  extends Omit<LoaderWrapperProps, 'dots' | 'className' | 'children'> {
  size?: LoaderSpinnerSizes;
}

export function LoaderSpinner({
  size = 'default',
  ...rest
}: LoaderSpinnerProps): ReactElement {
  const classes = `loader loader--${size}`;

  return (
    <LoaderWrapper {...rest} className={classes}>
      <div className="wrapper">
        <div className="wheel"></div>
      </div>
    </LoaderWrapper>
  );
}
